import React, { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";

const WebhookSelectModal = ({
    show,
    onClose,
    value,
    onSave,
    webhookList = [],
    smsWebhookList = [],
    title = "Webhook Configuration",
}) => {
    const [draftType, setDraftType] = useState("");
    const [draftId, setDraftId] = useState("");

    useEffect(() => {
        if (show) {
            setDraftType(value?.type || "");
            setDraftId(value?.id ? String(value.id) : "");
        }
    }, [show, value]);

    const handleTypeChange = (e) => {
        setDraftType(e.target.value);
        setDraftId("");
    };

    const handleSave = () => {
        if (!draftType || !draftId) {
            onSave(null);
            onClose();
            return;
        }
        onSave({ type: draftType, id: draftId });
        onClose();
    };

    const handleClear = () => {
        setDraftType("");
        setDraftId("");
        onSave(null);
        onClose();
    };

    const activeList = draftType === "webhook" ? webhookList : draftType === "sms_webhook" ? smsWebhookList : [];

    return (
        <Modal show={show} onHide={onClose} backdrop={false} style={{ zIndex: 1050 }} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group>
                        <Form.Label>Webhook Type (optional)</Form.Label>
                        <Form.Control as="select" value={draftType} onChange={handleTypeChange}>
                            <option value="">None</option>
                            <option value="webhook">Webhook</option>
                            <option value="sms_webhook">SMS Webhook</option>
                        </Form.Control>
                    </Form.Group>

                    {draftType && (
                        <Form.Group style={{ marginTop: 15 }}>
                            <Form.Label>
                                Select {draftType === "webhook" ? "Webhook" : "SMS Webhook"}
                            </Form.Label>
                            <Form.Control
                                as="select"
                                value={draftId}
                                onChange={(e) => setDraftId(e.target.value)}
                            >
                                <option value="">Select...</option>
                                {activeList.map((w) => (
                                    <option key={w.id} value={w.id}>
                                        {w.webhook_name || w.name}
                                    </option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    )}
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-danger" onClick={handleClear}>Clear</Button>
                <Button variant="primary" onClick={handleSave}>Save</Button>
                <Button variant="secondary" onClick={onClose}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default WebhookSelectModal;
